export const initialValues = {
  email: "",
  phoneNumber: "",
  firstName: "",
  lastName: "",
  streetAddress: "",
  otherInfo: "",
  postalCode: "",
  country: "",
  city: "",
  state: "",
  cardHolder: "",
  cardNumber: "",
  expirationDate: "",
  cvv: "",
};
